/**
 * Shared expert-review UI: QuestionTitle.tsx.
 *
 * Belongs here: reusable presentational piece.
 * Does not belong here: flow rules or API.
 */
interface QuestionTitleProps {
  displayText: string
  subText?: string
  subTextClassName?: string
  testLocator?: string
}

export function QuestionTitle({
  displayText,
  subText,
  subTextClassName,
  testLocator
}: QuestionTitleProps) {
  return (
    <div>
      <h2
        className={
          'text-[22px] font-[500] leading-[130%] text-[#232323]'
        }
        {...(testLocator ? { 'test-locator': testLocator } : {})}
      >
        {displayText}
      </h2>
      {subText ? (
        <p
          className={`pt-2 font-[400] text-[#6A6E6E] text-[13px] ${subTextClassName ?? ''}`.trim()}
        >
          {subText}
        </p>
      ) : null}
    </div>
  )
}
